import React, { useState, useEffect, useCallback } from "react";
import styled from "styled-components";
import GoogleMapRadius from "../../../components/GoogleMapRadius/GoogleMapRadius";
import {useSelector} from "react-redux";

const Heading = styled.h3`
  font-size: 23px;
  font-weight: 700;
  color: #0d1136;
  line-height: 1.2;
  margin-bottom: 25px;
  width: 100%;
  text-align: center;
`;

const Li = styled.li`
  margin: 0px !important;
  padding: 5px !important;
`

const DeliveryInfoEnglish = () => {
  const [latitude] = useState(11.558661);
  const [longitude] = useState(104.912052);

  const DelishopSection = () => (
      <>
        <div className="mb-4" style={{display: "inline-flex"}}>
          <h6 style={{fontSize: '21px', fontWeight: "bold"}}>For</h6>
          <h6 style={{fontSize: '21px', fontWeight: "bold", color: "#9cc54b", padding: "0px 5px"}}>Delishop Online Supermarket:</h6>
        </div>

        <div className="mb-4">
          <h6 className="mb-2"><u>DELIVERY TIME:</u></h6>
          <div>
            Any orders made on the website will be delivered the same day or 24h later<br/>
	          Our service is available from Monday to Sunday, from 10am to 8pm
          </div>
        </div>

        <div className="mb-4">
          <h6 className="mb-2"><u>SAME DAY DELIVERY:</u></h6>
          <div className="mb-2">
            You can order and get delivered the same day <b>if you order before 2pm</b> and on a selection of products.
          </div>

          <div className="mb-2">
            You can identify the items eligible to the same day delivery with the mention "GET IT TODAY"
          </div>

          <div>
            If some items in your cart are not eligible, you can not get your order today.
            Simply delete it from your cart to have access to the same day delivery
          </div>
        </div>

        <div className="mb-4">
          <h6 className="mb-2"><u>PAYMENT INFORMATION:</u></h6>
          <div>
            The minimum order is <b>$10</b>
          </div>
          <div className="mb-2">
            Exchange rate : $1 = 4100 Riels
          </div>

          <div>
            We accept payment :
            <ul style={{listStyleType: "disc"}}>
              {/* <Li>In cash, USD and/or Riels</Li>
              <Li>By ABA QR Code Transfer during delivery (on all our invoice)</Li>
            <Li>ABA, VISA, Mastercard during Check Out</Li> */}
            {/* new update info */}
              <Li>During Check Out: Local Bank Transfer, KHQR Transfer, Visa/Master, WeChat Pay, AliPay</Li>
              <Li>On Delivery: Cash (USD and/or Riels), ABAPay, KHQR Transfer</Li>
            </ul>
          </div>
        </div>

        <div className="mb-4">
          <h6 className="mb-2"><u>DELIVERY CONDITION:</u></h6>
          <div className="mb-2">
            You can choose a one-hour delivery time slot during the checkout process Our delivery crew will bring your order at your doorstep. (if you live in an apartment, please make sure we can get into the building)
          </div>

          <div className="mb-2">
            If a case of force majeure may force us to postpone chosen delivery dates and times, a customer service representative will call you.
          </div>

          <div className="mb-2">
            Alternatively, you may authorize someone to receive your order.<br/>
            (building management, neighbor, security…)
          </div>
        </div>

        <div className="mb-4">
          <h6 className="mb-2"><u>DELIVERY FEE:</u></h6>
          <div className="mb-2">
            Delivery fees are set as follows for Phnom Penh City:
          </div>

          <div className="mb-2">
            <div className="font-weight-bold">
              Radius 1   - 5km from Phnom Penh center
            </div>
	          <div>Delivery fee per km : $0.26</div>
            <div>Total amount to get free delivery : $50</div>
          </div>

          <div className="mb-2">
            <div className="font-weight-bold">Radius2 - 17km from Phnom Penh center</div>
	          <div>Delivery fee per km : $0.26</div>
            <div>Total amount to get free delivery : $100</div>
          </div>

          <div>If you are located above the Radius 2, your order will be delivered by Bus</div>
        </div>

        <h6><u>RADIUS</u></h6>
        <div>
          <GoogleMapRadius
              isMarkerShown={true}
              latitude={latitude}
              longitude={longitude}
              cartType="normal"
              zoom={11.3}
          />
        </div>
      </>
  )

  const DeliExpressSection = () => (
      <>
        <div className="mb-4 mt-5 pt-5" style={{display: "inline-flex"}}>
          <h6 style={{fontSize: '21px', fontWeight: "bold"}}>For</h6>
          <h6 style={{fontSize: '21px', fontWeight: "bold", color: "#f01266", padding: "0px 5px"}}> Delishop Express:</h6>
        </div>

        <div className="mb-4">
          <h6 className="mb-2"><u>DELIVERY TIME:</u></h6>
          <div>
            Any orders made on Delishop Express will be delivered as soon as possible, it will depend of the shop you have selected but mostly between 45 and 60mn.
          </div>
        </div>

        <div className="mb-4">
          <h6 className="mb-2"><u>PAYMENT INFORMATION:</u></h6>
          <div>
            The minimum order is <b>$10</b>
          </div>
          <div className="mb-2">
            Exchange rate : $1 = 4100 Riels
          </div>

          <div>
            We accept payment :
            <ul style={{listStyleType: "disc"}}>
              {/* <Li>In cash, USD and/or Riels</Li>
              <Li>By ABA QR Code Transfer during delivery (on all our invoice)</Li>
              <Li>ABA, VISA, Mastercard during Check Out</Li> */}
              {/* new update info */}
              <Li>During Check Out: Local Bank Transfer, KHQR Transfer, Visa/Master, WeChat Pay, AliPay</Li>
              <Li>On Delivery: Cash (USD and/or Riels), ABAPay, KHQR Transfer</Li>
            </ul>
          </div>
        </div>

        <h6 className="mb-4"><u>DELIVERY AREA:</u></h6>

        <h6>Delishop Express is available for customer located in this area :</h6>
        <div>
          <GoogleMapRadius
              isMarkerShown={true}
              latitude={latitude}
              longitude={longitude}
              cartType="express"
              zoom={13.4}
          />
        </div>
      </>
  )

  const ProvinceSection = () => (
      <>
        <div className="mb-4 mt-5 pt-5" style={{display: "inline-flex"}}>
          <h6 style={{fontSize: '21px', fontWeight: "bold"}}>For</h6>
          <h6 style={{fontSize: '21px', fontWeight: "bold", color: "orange", padding: "0px 5px"}}> Province:</h6>
        </div>

        <div className="mb-4">
          <h6 className="mb-2"><u>DELIVERY CONDITION:</u></h6>
          <div className="mb-2">
            We also deliver nationwide, just register your address and <b>select "Province"</b>. This will allow you to order the entire Delishop catalog and have it delivered to your area.
          </div>
          <p className="mb-2">
            We are now working in partnership with national carriers to provide Door to Door Delivery service to all provinces*.
          </p>
          <p className="mb-2">
            You may choose to select <b>"Door to Door"</b> or <b>"Pick up at Bus Station"</b> during the Checkout.
        </p>
          <p className="mb-2">If you order fresh or frozen products, we will carefully place them in a foam box with blocks of ice.</p>
          <p className="mb-2">
            However, we do not recommend this option as, once passed to our third-party carriers, your package is no longer under our supervision.
          </p>
          <p className="mb-2">
            Additional fees may occur depending on the number of boxes used to pack your order (average $2.5 per box)
          </p>
        </div>
        <div className="mb-4">
          <h6 className="mb-2"><u>DELIVERY TIME:</u></h6>
          <div className="mb-2">
            All orders with Province delivery are being packed and send through our carriers in the afternoon.
        </div>
          <p className="mb-2">The packages generally arrive the following morning (may vary depending on your location).</p>
        </div>

        <div className="mb-4">
          <h6 className="mb-2"><u>PAYMENT INFORMATION:</u></h6>
          <div>
            The minimum order is <b>$10</b>
          </div>
          <div className="mb-2">
            Exchange rate : $1 = 4100 Riels
          </div>

          <div>
            We accept only <b>online payment</b> :
            {/* <p>ABA, VISA, Mastercard during Check Out</p> */}
            <p>Local Bank Transfer, KHQR Transfer, Visa/Master, WeChat Pay, AliPay during Check Out</p>
            {/* <ul style={{listStyleType: "disc"}}>
              <Li>ABA, VISA, Mastercard during Check Out</Li>
            </ul> */}
          </div>
        </div>

        <div className="mb-4">
          <h6 className="mb-2"><u>DELIVERY FEE:</u></h6>
          <div>
            Fix delivery fee by bus : $4.50
          </div>
          <div className="mb-2">
            If any additional charge occurs due to large or heavy order, an extra fee will be communicated to you by our customer service team.
          </div>
          <p>*Door to Door Delivery to Mainland Cambodia only. Please contact our customer service for any specific orders to islands</p>
        </div>
      </>
  )
  return (
      <React.Fragment>
        <Heading>Delivery Information</Heading>
        <DelishopSection />
        <DeliExpressSection />
        <ProvinceSection/>
      </React.Fragment>
  )
}

export default DeliveryInfoEnglish;